export default __webpack_public_path__ + "static/media/teamchallenge_logo.0d8574c3.png";